import * as amplitude from '@amplitude/analytics-browser';
import { camelToSnakeCase } from './common';
export const amplSetUserProperty = (property, value) => {
    const identifyEvent = new amplitude.Identify();
    identifyEvent.append(property, value);
    amplitude.identify(identifyEvent);
};
export const amplTrack = (analyticsEvent) => {
    if (!analyticsEvent)
        return;
    amplitude.track(analyticsEvent.name, analyticsEvent);
};
export const amplSnakeCaseEventProperties = (obj, postfix = '') => {
    if (!obj)
        return {};
    return Object.entries(obj).reduce((result, [key, value]) => {
        const snakeCaseKey = camelToSnakeCase(key) + postfix;
        result[snakeCaseKey] = value;
        return result;
    }, {});
};
